import {ReactElement, useMemo} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, formatYearAndVersionType, keyify} from "../common";
import {Account} from "../../../../../contexts/chartofaccounts/ChartOfAccountsContext";
import {renderAccountPercentageMonthValue} from "./common";
import * as common from "../styles/common.module.scss";

const PERCENT_KEYS = [
    "percentMonth0",
    "percentMonth1",
    "percentMonth2",
    "percentMonth3",
    "percentMonth4",
    "percentMonth5",
    "percentMonth6",
    "percentMonth7",
    "percentMonth8",
    "percentMonth9",
    "percentMonth10",
    "percentMonth11"
];

export interface RenderUpdateAccPercentageDriverAssumptionsProps extends RendererProps {
    accounts: Account[];
}

export function RenderUpdateAccPercentageDriverAssumptions(props: RenderUpdateAccPercentageDriverAssumptionsProps): ReactElement {
    const accountMap = useMemo(() => {
        return props.accounts.toIdMap(a => a.id);
    }, [props.accounts]);

    const items = props.variables["items"];
    if(!Array.isArray(items)) {
        return <></>;
    }

    if(items.length === 0) {
        return <div>No change</div>;
    }

    const itemRenders: ReactElement[] = [];
    for(const item of items) {
        if(typeof item !== "object" || item === null) {
            continue;
        }

        const year = item["year"];
        const versionType = item["versionType"];
        const sourceAccountId = item["sourceAccountId"];

        let account: Account | undefined = undefined;
        if(typeof sourceAccountId === "string") {
            account = accountMap[sourceAccountId];
        }

        const itemKey = `${keyify(sourceAccountId)}`;

        const vals: ReactElement[] = [];
        for(let i = 0; i < 12; i++) {
            const percentKey = PERCENT_KEYS[i];

            if(!percentKey) {
                continue;
            }

            const percent = item[percentKey];
            if(percent === null || percent === undefined) {
                continue;
            }

            vals.push(<li key={`${itemKey}-${i}`}>
                {renderAccountPercentageMonthValue(i + 1, account, percent)}
            </li>);
        }

        itemRenders.push(
                <div key={itemKey} className={common.arrayItem}>
                    <div className={common.textHeader}>{formatYearAndVersionType(year, versionType)}</div>
                    <ul>
                        {vals}
                    </ul>
                </div>
        );
    }

    return <div>
        {itemRenders}
    </div>;
}